export var TOGGLE_ONE_CLICK_MODE = 'TOGGLE_ONE_CLICK_MODE';
export var SET_ONE_CLICK_AMOUNT = 'SET_ONE_CLICK_AMOUNT';
export var TOGGLE_ACCEPT_FACTOR_INCREASE = 'TOGGLE_ACCEPT_FACTOR_INCREASE';
export var TOGGLE_ACCEPT_FACTOR_DECREASE = 'TOGGLE_ACCEPT_FACTOR_DECREASE';



// WEBPACK FOOTER //
// ./src/actions/BettingMode.js